import { Indicator, Popover, PopoverDropdown, PopoverTarget, Text } from "@mantine/core"
import { IconBellFilled } from "@tabler/icons-react"

import { BlueActionButton } from "@/components/generic/BlueActionButton"
import classes from "./HeaderButtonNotifications.module.css"

export function HeaderButtonNotifications() {
  const hasNotifications = false
  return (
    <Popover width={200} position="bottom" withArrow shadow="md">
      <PopoverTarget>
        <Indicator color="yellow" offset={3} disabled={!hasNotifications}>
          <BlueActionButton data-testid="btn-show-notifications" aria-label={`Notifications ${hasNotifications ? "(has some notifications)" : "(no notifications)"}`} className={classes.button}>
            <IconBellFilled className={classes.icon} />
          </BlueActionButton>
        </Indicator>
      </PopoverTarget>
      <PopoverDropdown>
        <Text size="xs">This is uncontrolled popover, it is opened when button is clicked</Text>
      </PopoverDropdown>
    </Popover>
  )
}
